import I18n from 'I18n';
import { Small } from 'foundations-components/transitional/components/Small';
import { OBJECT_ID } from '../../../../constants/shared';
// @ts-expect-error untyped import
import { useFilterEdit } from '../FilterEditContext';
import ListFilterPanel from './ListFilterPanel';
import { Field, FieldTypes } from '../../../../schema/column-records';
import { Filter } from '../../../../schema/filter-records';
// @ts-expect-error untyped import
import SnowflakeFilterEditPopover from '../SnowflakeFilterEditPopover';
// @ts-expect-error untyped import
import SnowflakeFilterTile from '../SnowflakeFilterTile';
// @ts-expect-error untyped import
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
import ListFilterDisplayLabel from './ListFilterDisplayLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StagedListFilterTile = ({
  filterRef,
  index
}) => {
  const [editingState, editCallbacks] = useFilterEdit();
  const {
    table
  } = filterRef;
  const {
    editingStagedFilterIndex
  } = editingState;
  const handleRemove = () => {
    editCallbacks.handleRemoveStagedFilter(index);
  };
  const field = Field({
    name: OBJECT_ID,
    table,
    type: FieldTypes.NUMBER
  });
  const filter = Filter({
    field,
    filter: {
      filterType: 'IN_LIST',
      listId: undefined,
      operator: undefined
    }
  });
  const showEditPanel = index === editingStagedFilterIndex;
  const handleEdit = () => {
    editCallbacks.handleStagedFilterEdit(index);
  };
  const renderEditPanel = () => /*#__PURE__*/_jsx(ListFilterPanel, {
    filter: filter,
    onDone: ({
      draftFilter,
      draftGroupId
    }) => editCallbacks.handleStagedFilterChange(draftFilter, draftGroupId),
    onCancel: editCallbacks.handleCancelEdit
  });
  return /*#__PURE__*/_jsx(SnowflakeFilterTile, {
    children: /*#__PURE__*/_jsx(SnowflakeFilterEditPopover, {
      editPanel: renderEditPanel(),
      open: showEditPanel,
      onClose: editCallbacks.handleCancelEdit,
      children: /*#__PURE__*/_jsxs(SnowflakeFilterWrapper, {
        highlighted: showEditPanel,
        onEdit: handleEdit,
        onRemove: handleRemove,
        children: [/*#__PURE__*/_jsx(ListFilterDisplayLabel, {
          filter: filter
        }), /*#__PURE__*/_jsxs(Small, {
          use: "help",
          children: ["(", I18n.text('reporting-snowflake.filter-editor.click-to-apply'), ")"]
        })]
      })
    })
  });
};
export default StagedListFilterTile;